var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPageSize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 15,
    viewBox: "0 0 19.5 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2,.cls-4{fill:none}.cls-1,.cls-2{stroke:#748d6f;stroke-width:2px}.cls-1{stroke-linecap:round}.cls-3{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850",
    transform: "translate(-29.628 -65.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    "data-name": "Line 19",
    className: "cls-1",
    transform: "translate(40.374 69.422)",
    d: "M0 0h7.754"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_21",
    "data-name": "Line 21",
    className: "cls-1",
    transform: "translate(40.374 77.422)",
    d: "M0 0h7.754"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_905",
    "data-name": "Rectangle 905",
    className: "cls-2",
    transform: "translate(29.628 65.922)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 7,
    height: 7,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1,
    y: 1,
    width: 5,
    height: 5,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_906",
    "data-name": "Rectangle 906",
    className: "cls-2",
    transform: "translate(29.628 73.922)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 7,
    height: 7,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1,
    y: 1,
    width: 5,
    height: 5,
    rx: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageSize);
export default __webpack_public_path__ + "static/media/icon-page-size.7e210d25.svg";
export { ForwardRef as ReactComponent };